/*
 * Accordion
 */
const showTab = (tab) => {
  console.log("showTab", tab);
  const panel = tab.querySelector(".accordion-tab-panel");
  const toogleButton = tab.querySelector(".accordion-trigger");
  toogleButton.setAttribute("aria-expanded", "true");

  tab.classList.add("active");
  panel.style.height = "auto";

  var height = panel.clientHeight + "px";
  panel.style.height = "0px";

  setTimeout(function () {
    panel.style.height = height;
  }, 0);
};
const hideTab = (tab) => {
  console.log("hideTab", tab);
  const panel = tab.querySelector(".accordion-tab-panel");
  const toogleButton = tab.querySelector(".accordion-trigger");
  toogleButton.setAttribute("aria-expanded", "false");

  if (parseInt(panel.style.height) > 0) {
    panel.style.height = "0px";
    panel.addEventListener("transitionend", () => tab.classList.remove("active"), { once: true });
  } else {
    tab.classList.remove("active");
  }
};

const attachAccordion = (node) => {
  const multiple = node.dataset.multiple === "true";
  const tabs = Array.from(node.querySelectorAll(".a-accordion-tab"));
  tabs.forEach((tab) => {
    if (tab.classList.contains("active")) {
      const panel = tab.querySelector(".accordion-tab-panel");
      panel.style.height = panel.clientHeight + "px";
    }

    const toogleButton = tab.querySelector(".accordion-trigger");
    toogleButton.addEventListener("mousedown", (e) => {
      e.preventDefault();
      if (tab.classList.contains("active")) {
        hideTab(tab);
      } else {
        showTab(tab);
      }
      if (!multiple) {
        tabs.filter((t) => t !== tab).forEach((t) => hideTab(t));
      }
    });
  });
};

const createAccordion = (attributes) => {};

const razorAccordion = {
  selector: ".a-accordion",
  create: createAccordion,
  attach: attachAccordion,
};

export default razorAccordion;
